import { render, staticRenderFns } from "./ShopCommentManage.vue?vue&type=template&id=08c03e68&scoped=true"
import script from "./ShopCommentManage.vue?vue&type=script&lang=js"
export * from "./ShopCommentManage.vue?vue&type=script&lang=js"
import style0 from "./ShopCommentManage.vue?vue&type=style&index=0&id=08c03e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c03e68",
  null
  
)

export default component.exports